<template>
  <div class="course-progress" :class="{ dark }">
    <div class="wrapper">
      <strong>{{ data.completed }}</strong>/{{ data.total }} <span class="text">{{ text }}</span>
      <span v-if="!hidePercents" class="progress-value">({{ progress }}%)</span>
    </div>
    <span v-if="!hideProgressBar" class="progress-bar" :class="{ offset }">
      <span :style="{ width: `${progress}%` }" />
    </span>
    <span v-if="medal" class="medal">
      <MedalIcon v-if="certificate" class="certified" />
    </span>
    <MedalIcon v-else-if="certificate" class="certified" />
  </div>
</template>

<script>
import MedalIcon from '../assets/svg/courses/medal.svg?vue-component';

export default {
  components: { MedalIcon },
  props: {
    progress: { type: Number, required: true },
    data: { type: Object, required: true },
    text: { type: String, default: 'lessons' },
    // eslint-disable-next-line vue/require-default-prop
    certificate: { type: [Boolean, String] },
    hidePercents: Boolean,
    hideProgressBar: Boolean,
    dark: Boolean,
    offset: Boolean,
    medal: Boolean,
  },
};
</script>

<style lang="scss">
.course-progress {
  display: flex;
  align-items: center;
  width: 100%;

  .wrapper {
    font-size: 14px;
    flex: 0 0 auto;
    margin-right: var(--spacing-4);
  }

  .progress-value {
    color: var(--main-dark-light-4);
  }

  .progress-bar {
    display: inline-block;
    width: 100%;
    height: 6px;
    background-color: var(--main-light-shade-3);
    border-radius: 100px;
    border: 1px solid var(--main-light-shade-3);
    position: relative;

    &.offset {
      margin-left: 10px;
    }

    span {
      display: inline-block;
      background-color: var(--accent);
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      border-radius: 100px;
    }
  }

  .medal {
    min-width: 21px;
    height: 21px;
    margin-left: var(--spacing-4);
    margin-right: 0 !important;
    font-weight: unset !important;
    font-size: unset !important;
  }

  svg.certified {
    width: 21px;
    flex: 0 0 auto;

    path[fill] {
      fill: var(--accent);
    }

    path[stroke] {
      stroke: var(--accent);
    }
  }

  &.dark {
    gap: var(--spacing-8);

    .wrapper {
      margin: 0;
    }

    .progress-bar {
      margin: 0;
      background-color: var(--main-dark-light-3);
      border-color: var(--main-dark-light-4);
    }
  }
}

.fa {
  .course-progress {
    .progress-bar {
      span {
        background-color: var(--accent-light-3-400);
      }
    }

    svg.certified {
      path[stroke] {
        stroke: var(--accent-light-3);
      }

      path[fill] {
        fill: var(--accent);
      }
    }
  }
}
</style>
